//
//
//
//
//

import myview from './popUpPreview'
import axios from 'axios';
export default{
    data() {
        return {
            schema:{},
            status:1
        }
    },
    components:{
        myview:myview
    },
    methods: {
        getData(){
            let params = {
                uuid:this.query.uuid,
                lang:this.query.lang,
                streamNo:'web_saas' + (new Date()).getTime() + parseInt(Math.random() * 1000000),
                access_token:this.query.access_token,
                loginCustomerId:this.query.loginCustomerId
            }
            axios({
              method:"get",
              url: "/webmps/marketing/promotion/detail",
              headers:{'Accept-Language':this.query.lang},
              params:params
            }).then(res => {
              this.schema = res.data.data.conf_schema || {};
              this.status = res.data.data.status;
            }).catch(err => {

            })
        }
    },
    created(){
        this.query = this.$route.query;
        if(this.query['amp;lang'] || this.query['amp%3Blang']) {
            this.query['lang'] = this.query['amp;lang'] || this.query['amp%3Blang'];
        }
        if(this.query.lang != undefined && this.query.lang.indexOf('?') == -1){
            this.getData();
        }else if(this.query.lang && this.query.lang.indexOf('?') != -1){
            this.status = 3;//版本低状态
        }else{
            this.status = 3//参数异常状态
        }


    }
}



// WEBPACK FOOTER //
// ./src/views/index.vue